export const aboutData = {
  brandName: '鲍鱼视频',
  tagline: '从海底到餐桌，记录鲍鱼的每一刻',
  intro: '鲍鱼视频成立于2020年，是国内首家专注于鲍鱼全产业链视频内容的垂直平台。我们汇聚了来自全国各大鲍鱼养殖基地、捕捞团队、加工企业和名厨团队的专业视频资源，致力于打造最全面、最权威的鲍鱼知识视频库。',
  mission: '让每一个热爱海鲜的人，都能通过我们的视频深入了解鲍鱼的完整生命周期——从深海养殖到捕捞上岸，从精密加工到精致烹饪。我们相信，了解食物来源的人，会更加珍惜每一份来自海洋的馈赠。',
  milestones: [
    { year: '2020', event: '鲍鱼视频平台正式上线，收录首批500+高清鲍鱼视频内容' },
    { year: '2021', event: '与5大鲍鱼养殖基地建立内容合作关系，推出养殖技术系列专题' },
    { year: '2022', event: '平台视频总量突破2000部，月活跃用户突破50万' },
    { year: '2023', event: '邀请10位五星级酒店名厨入驻，推出名厨烹饪教学专栏' },
    { year: '2024', event: '获得年度最佳垂直内容平台奖，用户覆盖全球30+国家和地区' },
    { year: '2025', event: '平台全面升级，新增AI智能推荐和超高清4K视频播放功能' },
    { year: '2026', event: '启动"走进鲍鱼之乡"系列纪录片项目，深入全球鲍鱼产区拍摄' },
  ],
  team: [
    { name: '陈海生', role: '创始人 & CEO', bio: '海洋生物学博士，前国家级水产研究所研究员，拥有15年鲍鱼养殖与育种研究经验。' },
    { name: '林美琪', role: '内容总监', bio: '资深美食媒体人，曾任《海鲜美食》杂志主编，对海洋食材有独到的品味和见解。' },
    { name: '王明哲', role: '技术总监', bio: '全栈工程师，前字节跳动视频技术团队成员，专注视频播放与推荐算法优化。' },
    { name: '张丽华', role: '运营总监', bio: '资深互联网运营专家，曾主导多个百万级用户社群运营项目。' },
  ],
  contact: {
    email: 'contact@baoyushipin.com',
    phone: '400-888-9999',
    wechat: 'baoyushipin',
    address: '广东省深圳市南山区科技园南路88号海洋科技大厦18层',
    workHours: '周一至周五 9:00-18:00',
  },
};